<template>
  <v-dialog v-model="dialog" max-width="900">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Add discounts</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <date-range-picker
              :gt-date-from-string="validFrom"
              :gt-date-to-string="validTo"
              @onRangeSelected="onDateRangeSelected"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-col>
          <v-col sm="3">
            <date-picker
              :gt-date-string="bookBeforeDate"
              custom-label="Book Before"
              @onDateSelected="onBookBeforeSelected"
              :outlined="outlinedInputs"
            ></date-picker>
          </v-col>
          <v-col sm="2">
            <v-text-field
              type="number"
              label="Advance Days"
              v-model="advanceDays"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <gt-multi-select
              label="Services"
              :items="inUseServices"
              select-all
              v-model="selectedServices"
              item-text="node.name"
              item-value="node.id"
              :show-selected="2"
              :outlined="outlinedInputs"
            ></gt-multi-select>
          </v-col>
          <v-col>
            <agent-group-select
              v-model="agentGroup"
              :outlined="outlinedInputs"
            ></agent-group-select>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col sm="6">
            <v-text-field
              type="text"
              label="Description"
              v-model="description"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Book (Min Duration)"
              v-model="minBook"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Free"
              v-model="free"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Discount %"
              v-model="percent"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col>[{{ agentGroup }}] [{{ services }}] [{{ description }}]</v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="grey lighten-3">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="dialog = false">Close</v-btn>
        <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from "../../shared/DatesRangePicker";
import DatePicker from "../../shared/DatePicker";
import AgentGroupSelect from "../../shared/AgentGroupSelect";

import GtMultiSelect from "../../shared/GtMultiSelect";
export default {
  name: "add-discounts-dialog",
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DateRangePicker,
    DatePicker,
    AgentGroupSelect,
    GtMultiSelect,
  },
  data() {
    return {
      debug: false,
      dialog: false,
      validFrom: "",
      validTo: "",
      bookBeforeDate: "",
      advanceDays: 0,
      selectedServices:
        this.services.length > 0
          ? this.services.filter((s) => !s.node.notInUse).map((s) => s.node.id)
          : [],
      agentGroup: "",
      minBook: 0,
      free: 0,
      percent: 0,
      description: "",
    };
  },
  computed: {
    inUseServices() {
      return this.services.filter((s) => !s.node.notInUse);
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.validFrom != "" &&
        this.validTo != "" &&
        (this.bookBeforeDate != "" || this.advanceDays > 0) &&
        this.description != "" &&
        this.selectedServices.length > 0
      );
    },
  },
  methods: {
    onDateRangeSelected(range) {
      this.validFrom = range.dateFrom;
      this.validTo = range.dateTo;
    },
    onBookBeforeSelected(date) {
      this.bookBeforeDate = date;
    },
    onSave() {
      this.dialog = false;
      this.$emit("create", {
        validFrom: this.validFrom,
        validTo: this.validTo,
        bookBeforeDate:
          this.bookBeforeDate != "" ? this.bookBeforeDate : undefined,
        advanceDays: Number(this.advanceDays),
        services: this.selectedServices,
        groupId: this.agentGroup,
        minBook: Number(this.minBook),
        free: Number(this.free),
        percent: Number(this.percent),
        description: this.description,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/discounts/AddDiscountsDialog.vue